import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AppContext from '@/context/Context';
import { useContext } from 'react';
import type { ComponentProps } from 'react';

type LogoAt = 'auth' | 'navbar-vertical' | 'navbar-top';

interface LogoProps extends Omit<ComponentProps<typeof Link>, 'to'> {
  at?: LogoAt;
  width?: number;
  className?: string;
}

const Logo = ({
  at = 'auth',
  width = 58,
  className,
  ...rest
}: LogoProps) => {
  const {
    config: { theme },
  } = useContext(AppContext);

  return (
    <Link
      to="https://mizfa.tools/"
      className={classNames('text-decoration-none', {
        'navbar-brand text-left':
          at === 'navbar-vertical' || at === 'navbar-top',
      })}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth',
          },
          className,
        )}
      >
        <img
          className="me-0 d-lg-block d-none"
          src={
            theme === 'dark'
              ? 'https://static.mizfa.tools/img/logo/logo-page/mizfa-tools-v1-white-min.svg'
              : 'https://static.mizfa.tools/homepage/mizfa-tools-v1-low.svg'
          }
          loading="lazy"
          alt="لوگوی میزفا"
          style={{ maxWidth: '100%', height: 42 }}
          height="auto"
          width={width}
        />
        <img
          className="me-0 d-lg-none d-block"
          src="https://static.mizfa.tools/img/logo/logo-page/mizfa-tools-no-text.svg"
          loading="lazy"
          alt="لوگوی میزفا"
          style={{ maxWidth: 42, height: 42 }}
          height="auto"
          width={42}
        />
      </div>
    </Link>
  );
};

export default Logo;
